import {Select as AntdSelect, SelectProps as AntdSelectProps} from 'antd'

import './Select.scss'
import {Loader, DropdownIcon} from 'common/components'

interface SelectProps extends AntdSelectProps {
  readOnly?: boolean
}

export default function Select({readOnly, loading, ...props}: SelectProps) {
  return (
    <AntdSelect
      className={readOnly ? 'Select Select_readOnly' : undefined}
      suffixIcon={<DropdownIcon />}
      notFoundContent={loading ? <Loader small /> : undefined}
      open={readOnly ? false : undefined}
      showArrow={readOnly ? false : true}
      {...props}
    />
  )
}
